import history from '../history';

export class HistoryHelper {
  static redirectTo(url = '') {
    return history.push(url);
  }
}
